<template>
  <div class="page-card-template-container">
    <div class="card-container">
      <div class="card-top-container">
        <div class="top-title">{{ title || route.meta?.title || "" }}</div>
        <div>
          <el-button @click="handleBack">返回</el-button>
        </div>
      </div>
      <div class="card-body-container">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
import { useRouter, useRoute } from "vue-router";

const router = useRouter();
const route = useRoute();

defineProps({
  title: {
    type: String,
    default: "",
  },
});

const handleBack = () => {
  router.back();
};
</script>

<style lang="scss" scoped>
.page-card-template-container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 15px;
  .card-container {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 10px;
    box-sizing: border-box;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    overflow: auto;
    padding: 10px;
    display: flex;
    flex-direction: column;
    .card-top-container {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 20px;
      border-bottom: 1px solid var(--el-border-color);
      .top-title {
        font-weight: 800;
      }
    }
    .card-body-container {
      flex: 1 1 auto;
      overflow: auto;
      padding: 10px 20px;
    }
  }
}
</style>
